import React from 'react';
import Loadable from 'react-loadable';
import { getPositions } from 'api';
import { getEquipmentTypeListAll } from 'pages/PageEquipmentTypePprList/api';
import LoadableLoading from 'components/LoadableLoading';
import { getTechnicalRoomAvailableColumns } from './views/TechnicalRoomList/api';

export const path = '/real-estate';

const PageRealEstate: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      positions: getPositions,
      equipmentTypes: getEquipmentTypeListAll,
      technicalRoomColumns: getTechnicalRoomAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}): React.ReactNode {
      const Page: any = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageRealEstate;
